import { EqualsOperation } from 'sift/es/index.js';

class $CustomExists extends EqualsOperation {
  next(item, key, owner) {
    if (Array.isArray(item)) {
      if (item.length > 0 === this.params) {
        this.done = true;
        this.keep = true;
      }
      return;
    }

    const regularItem = owner.$data || owner || {};

    const condition =
      item &&
      item.$containerField &&
      item.$containerField.isComputed &&
      item.$containerField.searchable
        ? item.value !== undefined
        : // eslint-disable-next-line no-prototype-builtins
          regularItem.hasOwnProperty(key) &&
          (!owner.$fields || owner.$fields[key].searchable !== false);

    if (condition === this.params) {
      this.done = true;
      this.keep = true;
    } else if ((item !== undefined) === this.params) {
      this.done = true;
      this.keep = true;
    }
  }
}

export default {
  operations: {
    $exists(params, ownerQuery, options) {
      const existsOperation = new $CustomExists(params, ownerQuery, options);
      delete existsOperation._test;

      return existsOperation;
    }
  }
};
